var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "94px",
    height: "75px",
    viewBox: "0 0 94 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-not-found-7099370") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-10",
    transform: "translate(-673, -246)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-not-found-7099370",
    transform: "translate(673, 246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125,0 C1.3984,0 0,1.3984 0,3.125 L0,75 L93.75,75 L93.75,3.125 C93.75,1.3984 92.3516,0 90.625,0 L3.125,0 Z",
    id: "Path",
    fill: "#00467D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.625,6.25 C42.3516,6.25 43.75,7.6484 43.75,9.375 C43.75,11.1016 42.3516,12.5 40.625,12.5 C38.8984,12.5 37.5,11.1016 37.5,9.375 C37.5,7.6484 38.8984,6.25 40.625,6.25 Z M28.125,6.25 C29.8516,6.25 31.25,7.6484 31.25,9.375 C31.25,11.1016 29.8516,12.5 28.125,12.5 C26.3984,12.5 25,11.1016 25,9.375 C25,7.6484 26.3984,6.25 28.125,6.25 Z M15.625,6.25 C17.3516,6.25 18.75,7.6484 18.75,9.375 C18.75,11.1016 17.3516,12.5 15.625,12.5 C13.8984,12.5 12.5,11.1016 12.5,9.375 C12.5,7.6484 13.8984,6.25 15.625,6.25 Z M90.625,71.875 L3.125,71.875 L3.125,18.75 L61.516,18.75 L72.454,10.9375 L90.626,10.9375 L90.625,71.875 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875,25 C35.656,25 26.563,34.0938 26.563,45.312 C26.563,56.5302 35.6568,65.624 46.875,65.624 C58.0932,65.624 67.187,56.5302 67.187,45.312 C67.187,34.0938 58.0932,25 46.875,25 Z M56.8203,50.836 L52.4023,55.254 L46.875,49.7306 L41.3516,55.254 L36.9336,50.836 L42.457,45.3126 L36.9336,39.7892 L41.3516,35.3712 L46.875,40.8946 L52.3984,35.3712 L56.8164,39.7892 L51.293,45.3126 L56.8203,50.836 Z",
    id: "Shape",
    fill: "#8B131C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.5a793c00fa0f0efa0e263580071fb051.svg";
export { ForwardRef as ReactComponent };